import React, { useEffect, useRef, useState } from 'react';
import {
  Modal,
  Box,
  Typography,
  IconButton,
  Table,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Paper,
} from '@mui/material';
import COLORS from '../../../../resources/style/Themes';
import ChatSideBar from '../../../../components/chat/helpers/ChatSideBar';
import {
  ScreenType,
  useHandleScreenSize,
} from '../../../../context_providers/screen_context/ScreenSizeProvider';
import { StringKeys } from '../../../../resources/strings/StringKeys';
import { useTranslation } from 'react-i18next';
import Message from '../../../../components/chat/chat_message_types/Messages';
import { Phone } from '@mui/icons-material';

function ArchivedChat(props) {
  const chatTableRef = useRef();
  const [responseData, setResponseData] = useState();
  const [emergency, setEmergency] = useState(null);
  const [emergencyMessages, setEmergencyMessages] = useState([]);
  const [showEmergencyResponseTeam, setShowEmergencyResponseTeam] =
    useState(true);
  const { screenType } = useHandleScreenSize();
  const { t } = useTranslation();

  const toggleEmergencyResponseTeam = () => {
    setShowEmergencyResponseTeam(!showEmergencyResponseTeam);
  };
  useEffect(() => {
    if (props.selectedEmergency && props.selectedEmergency.emergency) {
      setEmergency(props.selectedEmergency.emergency);
      const messages = props.selectedEmergency.emergency_messages || [];
      setEmergencyMessages(messages);
    }
  }, [props.selectedEmergency]);

  useEffect(() => {
    setResponseData();
    if (props.selectedEmergency && props.selectedEmergency.emergency_messages) {
      const temps = props.selectedEmergency.emergency_messages;
      setResponseData(temps);
    }
  }, [props.selectedEmergency]);

  useEffect(() => {
    chatTableRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [responseData]);

  const renderResponseTeam = () => {
    if (emergency && emergency.users) {
      if (emergency.users.length === 0) {
        return (
          <Typography
            style={{
              color: screenType === ScreenType.LARGE ? COLORS.WHITE : null,
            }}
          >
            {t(StringKeys.THIS_USER_HAS_NO_EMERGENCY_RESPONSE_TEAM_MEMBERS)}
          </Typography>
        );
      }
      return (
        <Box sx={{ height: '90%', overflowY: 'auto', padding: 0 }}>
          <TableContainer>
            <Table>
              <TableBody>
                {emergency.users.map((item, index) => (
                  <TableRow key={index}>
                    <TableCell
                      style={{
                        border: 'none',
                        color:
                          screenType === ScreenType.LARGE ? COLORS.WHITE : null,
                      }}
                    >
                      {item.first_name} {item.last_name}
                    </TableCell>
                    <TableCell
                      style={{
                        border: 'none',
                        color:
                          screenType === ScreenType.LARGE ? COLORS.WHITE : null,
                      }}
                    >
                      {item.phone_number}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      );
    } else {
      return (
        <Typography
          style={{
            color: screenType === ScreenType.LARGE ? COLORS.WHITE : null,
          }}
        >
          {t(StringKeys.THIS_USER_HAS_NO_EMERGENCY_RESPONSE_TEAM_MEMBERS)}
        </Typography>
      );
    }
  };

  const renderData = () => {
    if (emergencyMessages.length > 0) {
      return (
        <TableContainer component={Paper} sx={{ boxShadow: 0 }}>
          <Table sx={{ tableLayout: 'fixed' }}>
            <TableBody>
              {emergencyMessages.map((message, index) => (
                <TableRow key={index}>
                  <TableCell
                    sx={{
                      border: 'none',
                      padding: 0,
                      margin: 0,
                      maxWidth: '80%',
                      wordBreak: 'break-word',
                      overflowX: 'hidden',
                    }}
                  >
                    <Message data={message} emergency={emergency} />
                  </TableCell>
                </TableRow>
              ))}
              <TableRow ref={chatTableRef}></TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      );
    }
  };

  return (
    <>
      {emergency ? (
        <Modal
          open={props.show}
          onClose={props.onHide}
          aria-labelledby="chat-modal-title"
          aria-describedby="chat-modal-description"
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Box
            sx={{
              width: { xs: '90%', sm: '90%', md: '90%', lg: '70%' },
              bgcolor: 'background.paper',
              borderRadius: 3,
              boxShadow: 24,
              p: 0,
              outline: 'none',
            }}
          >
            <Box
              sx={{
                backgroundColor: COLORS.SAFEGUARD_BLUE,
                color: COLORS.WHITE,
                borderRadius: '10px 10px 0 0',
                height: '90px',
                textAlign: 'center',
                position: 'relative',
                padding: 0,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Typography variant="h6" id="chat-modal-title">
                {emergency.creator_first_name} {emergency.creator_last_name} -{' '}
                {(() => {
                  if (emergency.incident === 'SOS Button')
                    return t(StringKeys.SOS_BUTTON);
                  if (emergency.incident === 'Arc Flash')
                    return t(StringKeys.ARC_FLASH);
                  if (emergency.incident === 'Head Impact')
                    return t(StringKeys.HEAD_IMPACT);
                  if (emergency.incident === 'Dangerous Fall')
                    return t(StringKeys.DANGEROUS_FALL);
                })()}
              </Typography>
              <IconButton
                sx={{
                  color: COLORS.WHITE,
                  position: 'absolute',
                  right: 8,
                  top: 8,
                }}
                onClick={props.onHide}
              >
                &times;
              </IconButton>
              <Typography variant="subtitle1">
                <Phone height={20} /> {emergency.creator_phone_number}
              </Typography>
            </Box>
            <Box
              sx={{ display: 'flex', height: '500px', flexDirection: 'row' }}
            >
              {screenType !== ScreenType.SMALL && (
                <Box
                  sx={{
                    backgroundColor: COLORS.SAFEGUARD_BLUE,
                    padding: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    width: '60px',
                    transition: 'width 0.3s ease',
                  }}
                >
                  <ChatSideBar
                    toggleEmergencyResponseTeam={toggleEmergencyResponseTeam}
                  />
                </Box>
              )}
              {showEmergencyResponseTeam && screenType !== ScreenType.SMALL && (
                <Box
                  className="gradient-background"
                  sx={{
                    flex: 1,
                    overflowY: 'auto',
                    padding: 2,
                    backgroundColor: COLORS.SAFEGUARD_BLUE,
                    color: COLORS.WHITE,
                    maxWidth: '300px',
                    transition: 'max-width 0.3s ease',
                  }}
                >
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: 'bold', mb: 1 }}
                  >
                    {t(StringKeys.USERS_RESPONSE_TEAM, {
                      user: `${emergency.creator_first_name} ${emergency.creator_last_name}`,
                    })}
                  </Typography>
                  {renderResponseTeam()}
                </Box>
              )}
              <Box
                sx={{
                  overflowY: 'auto',
                  overflowX: 'hidden',
                  maxHeight: '500px',
                  padding: 2,
                  flex: 1,
                }}
              >
                {renderData()}
              </Box>
            </Box>
          </Box>
        </Modal>
      ) : null}
    </>
  );
}

export default ArchivedChat;
